import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import { Trans, useTranslator } from 'tradera/lang/translate';
import { closeModal } from 'tradera/state/ui/reducer';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import BookmarkIcon from '@tradera/blueprint/theme/icons2/bookmark.svg?jsx';
import SaveSearchImage from './save-search.png';
import { SAVE_SEARCH_MODAL_DISMISSED } from 'tradera/constants/cookies';
import cookieUtil from 'tradera/utils/cookie';
import { SaveSearchButton } from './save-search/save-search-button';
import * as searchGtm from 'tradera/apps/tradera/components/discover/helpers/search-gtm';

import styles from './save-search-modal.module.scss';

const saveModalDismissed = () => {
    const count =
        parseInt(cookieUtil.readCookie(SAVE_SEARCH_MODAL_DISMISSED)) || 0;
    const expiresSixMonths = dayjs().add(6, 'months').toDate();
    cookieUtil.createCookie(
        SAVE_SEARCH_MODAL_DISMISSED,
        count + 1,
        expiresSixMonths
    );
};

export const SAVE_SEARCH_MODAL_ID = 'saveSearchModalId';

export const SaveSearchModal = ({ queryParams = {} }) => {
    const { t } = useTranslator();
    const dispatch = useDispatch();

    const [emailToggleEnabled, setEmailToggleEnabled] = useState(true);

    const { q } = queryParams;

    const handleCloseModal = () => {
        searchGtm.trackAction(searchGtm.GA_EVENT_SAVE_SEARCH_MODAL, 'Dismiss');
        saveModalDismissed();
        dispatch(closeModal());
    };

    const handleSaveClick = () => {
        dispatch(closeModal());
    };

    return (
        <ScrollableModal
            maxWidth={'32rem'}
            maxHeight={'40rem'}
            onClose={handleCloseModal}
            mobileBottomSheet
            show
            footer={
                <div className="d-flex flex-column">
                    <SaveSearchButton
                        type="no-icon"
                        showHint={false}
                        successToast={true}
                        saveText={t('searchResults_saveSearchModal_save')}
                        emailDefaultOff={!emailToggleEnabled}
                        onSaveClick={handleSaveClick}
                        gaActionString={searchGtm.GA_EVENT_SAVE_SEARCH_MODAL}
                    />
                </div>
            }>
            <div className="d-flex flex-column">
                <button
                    className={`btn btn-round ${styles.saveSearchModalClose}`}
                    onClick={handleCloseModal}>
                    <CloseIcon className="icon icon-md" />
                </button>
                <img
                    className={`mx-auto mb-4 ${styles.saveSearchImage}`}
                    src={SaveSearchImage}
                />
                <p className="heading-london text-styled text-center">
                    {t('searchResults_saveSearchModal_headline')}{' '}
                </p>
                <p>
                    <Trans
                        i18nKey="searchResults_saveSearchModal_text_Trans"
                        components={{ strong: <strong /> }}
                        values={{ searchName: q }}
                    />
                    <BookmarkIcon className="icon ml-1 align-text-bottom" />
                </p>
                <div>
                    <div className="form-toggle">
                        <label className="form-toggle-label d-flex justify-content-between align-items-center text-gray-600	pl-0">
                            <span>
                                {t('searchResults_saveSearchModal_email')}
                            </span>
                            <input
                                type="checkbox"
                                className={`form-toggle-input ${styles.saveSearchModalToggleInput}`}
                                checked={emailToggleEnabled}
                                onChange={() => {
                                    searchGtm.trackAction(
                                        searchGtm.GA_EVENT_SAVE_SEARCH_MODAL,
                                        `Email toggle - ${
                                            !emailToggleEnabled ? 'On' : 'Off'
                                        }`
                                    );

                                    setEmailToggleEnabled(!emailToggleEnabled);
                                }}
                            />
                        </label>
                    </div>
                </div>
            </div>
        </ScrollableModal>
    );
};
